export default "__VITE_ASSET__9559b6e4__"